import { Badge, Grid, Group, Paper, Stack, Text } from '@mantine/core'
import dayjs from 'dayjs'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'
import { CompanyItem } from './types'

interface CompanyCardProps {
  company: CompanyItem
}

const CompanyCard: React.FC<CompanyCardProps> = ({ company }) => {
  const theme = useTheme()

  const formatDate = (dateStr: string) => {
    if (!dateStr) return '-'
    return dayjs(dateStr).format('YYYY-MM-DD')
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case '存续':
        return 'green'
      case '注销':
        return 'red'
      case '吊销':
        return 'orange'
      default:
        return 'gray'
    }
  }

  const getRelationshipText = (relationship: string) => {
    switch (relationship) {
      case 'sh':
        return '股东'
      case 'lp':
        return '法人'
      case 'tm':
        return '高管'
      default:
        return relationship
    }
  }

  const getRelationshipColor = (relationship: string) => {
    switch (relationship) {
      case 'sh':
        return 'purple'
      case 'lp':
        return 'blue'
      case 'tm':
        return 'cyan'
      default:
        return 'gray'
    }
  }

  const cardBackgroundColor = '#ffffff'

  return (
    <Paper
      p="md"
      style={{
        backgroundColor: cardBackgroundColor,
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.05)',
      }}
    >
      <Stack gap="sm">
        <Group justify="space-between" align="flex-start">
          <Stack gap="xs" style={{ flex: 1 }}>
            <Group gap="sm" align="center">
              <Text size="sm" fw={600} style={{ color: theme?.primaryColor || '#1c7ed6' }}>
                {company.orgName}
              </Text>
              <Badge color={getStatusColor(company.basicInfo.regStatus)} variant="light" size="sm">
                {company.basicInfo.regStatus}
              </Badge>
            </Group>

            <Group gap="xs">
              {company.relationship.map((rel, index) => (
                <Badge key={index} color={getRelationshipColor(rel)} variant="light" size="sm">
                  {getRelationshipText(rel)}
                </Badge>
              ))}
            </Group>
          </Stack>
        </Group>

        <Grid gutter="xs">
          <Grid.Col span={6}>
            <Text size="xs" c="dimmed">
              统一社会信用代码
            </Text>
            <Text size="sm" fw={500}>
              {company.basicInfo.creditCode || '-'}
            </Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text size="xs" c="dimmed">
              注册资本
            </Text>
            <Text size="sm" fw={500}>
              {company.basicInfo.regCapital || '-'}
            </Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text size="xs" c="dimmed">
              成立日期
            </Text>
            <Text size="sm" fw={500}>
              {formatDate(company.basicInfo.estiblishTime)}
            </Text>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text size="xs" c="dimmed">
              法定代表人
            </Text>
            <Text size="sm" fw={500}>
              {company.basicInfo.legalPersonName || '-'}
            </Text>
          </Grid.Col>
        </Grid>
      </Stack>
    </Paper>
  )
}

export default CompanyCard
